import logo from './logo.svg';
import './App.css';
import VR_Main from './vr_dyana/vr_main.tsx';

import './style.scss'

function App() {
  return (

    <VR_Main/>
  );
}

export default App;
